import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts';
import { canAccessRoute } from '../permissions';
import { AccessDenied } from './AccessDenied';

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * Route guard — checks sidebar RBAC via `canAccessRoute`.
 * Expects AuthContext to already supply trusted/effective role
 * (superAdmin→CEO, active manager/support, else denied before Admin shell).
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { role, permissionsVersion, canEnterAdminShell } = useAuth();
  const { pathname } = useLocation();

  void permissionsVersion;

  if (!canEnterAdminShell || !canAccessRoute(role, pathname)) {
    return <AccessDenied />;
  }

  return children;
}
